<template>
  <div v-if="currentCircle">
    <a-modal
      v-model="showModal"
      width="587px"
      :maskClosable="false"
      @ok="hide"
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      :closable="false"
      class="onboarding-modal"
    >
      <template #title>
        <div class="d-flex align-items-center">
          <font-awesome-icon size="1x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
          <h5 class="fw700 font20 gray700 mb-0">Add a Condition</h5>
          <a-button
            key="submit"
            type="primary"
            :disabled="!selectedCircle"
            @click="save()"
            class="primary-button saveButton font-white show-in-mobile ml-auto"
            :style="{ background: getPrimaryColor(), opacity: selectedCircle ? '1' : '0.3', border: 'none' }"
            :loading="saving"
          >
            {{ saving ? "Saving..." : "Save" }}
          </a-button>
          <font-awesome-icon size="1x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto font20 cp" @click="hide" />
        </div>
      </template>
      <template #footer>
        <a-button
          key="submit"
          type="primary"
          :disabled="!selectedCircle"
          @click="save()"
          class="primary-button saveButton hide-in-mobile"
          :style="{ background: getPrimaryColor(), opacity: selectedCircle ? '1' : '0.3', border: 'none' }"
          :loading="saving"
        >
          <span :style="{ color: '#fff !important' }"> {{ saving ? "Saving..." : "Save" }} </span>
        </a-button>
      </template>
      <div class="dovemed-wrapper text-center signup-page symptoms-body">
        <div class="signup-container">
          <div class="row mb-4">
            <div class="col-12 text-left position-relative">
              <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon-one gray400" />
              <label class="font-weight-bold input-label"> Search Condition </label>
              <a-select
                show-search
                :size="'large'"
                placeholder="Search Condition"
                allowClear
                v-model="selectedCircle"
                :default-value="defaultCircle"
                :filterOption="false"
                class="w-100 selectMain onboarding-modal-selects"
                @search="searchOtherCircles"
                @change="handleOtherCircle"
              >
                <a-select-option v-if="loading1" :key="0" :disabled="true">
                  <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                </a-select-option>
                <template v-else>
                  <a-select-option v-for="circle in circleList" :key="circle.id" :value="circle.id">
                    <!-- <a-select-option v-for="circle in circleList" :key="circle.id" :value="circle.display_name"> -->
                    {{ circle.display_name }}
                  </a-select-option>
                </template>
              </a-select>
              <div class="mt-4 mb-2 position-relative type-input">
                <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon-two gray400" />
                <label class="font-weight-bold input-label"> Search Symptom </label>
                <a-select
                  mode="multiple"
                  :size="'large'"
                  placeholder="Search Symptom"
                  allowClear
                  :filterOption="false"
                  :value="symptoms ? symptoms.map(ele => ele.display_name) : undefined"
                  notFoundContent=""
                  class="w-100 selectMain sideEffectSelect onboarding-modal-selects"
                  @search="searchSymptoms"
                  @change="handleSymptoms"
                  :disabled="selectedCircle ? false : true"
                >
                  <a-select-option v-if="loading2" :key="0" :disabled="true">
                    <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                  </a-select-option>
                  <template v-else>
                    <!-- <a-select-option v-for="symptom in symptomsList" :key="symptom.id" :value="symptom"> -->
                    <a-select-option v-for="symptom in symptomsList" :key="symptom.id" :value="symptom.display_name">
                      {{ symptom.display_name }}
                    </a-select-option>
                  </template>
                </a-select>
              </div>
              <div v-if="symptoms && selectedCircle" class="mt-4">
                <div v-for="(symptom, index) in symptoms" :key="index">
                  <div class="symptoms-lists mt-2">
                    <div class="symp-name mob-one">
                      {{ symptom.display_name }}
                    </div>
                    <div class="symptom-radio mob-three">
                      <div class="symp-radiobtn">
                        <input class="cp" type="radio" value="0" :checked="symptom.effectiveness === '0'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label class="sideEffectButton">Mild</label>
                      </div>
                      <div class="symp-radiobtn">
                        <input class="cp" type="radio" value="50" :checked="symptom.effectiveness === '50'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label class="sideEffectButton">Moderate</label>
                      </div>
                      <div class="symp-radiobtn">
                        <input class="cp" type="radio" value="100" :checked="symptom.effectiveness === '100'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label class="sideEffectButton">Severe</label>
                      </div>
                    </div>
                    <!-- <div
                      class="symptom-delete"
                    > -->
                    <font-awesome-icon @click="removeSymptom(symptom.display_name)" size="1x" class="error300 delete-margin cp symptom-delete mob-two" :icon="['fas', 'trash']" />
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
// import 'ant-design-vue/dist/antd.css';

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "UserOtherSymptoms",
  data() {
    return {
      symptoms: [],
      flag: true,
      showModal: false,
      savedSymptoms: [],
      savedSymptomsValues: [],
      otherSymptoms: null,
      load: false,
      symptomsList: [],
      // otherSymptomsList: [],
      other_symptoms: [],
      selectedCircle: undefined,
      circleList: [],
      fetchOther: null,
      defaultSymptoms: [],
      defaultSideEffects: undefined,
      defaultCircle: [],
      saving: false,
      loading1: false,
      loading2: false,
    }
  },
  validations: {
    symptoms: {
      // required
    },
  },

  created() {
    this.searchOtherCircles("a")
  },

  methods: {
    show(key, symtp = [], othrSympt, init) {
      console.warn("OtherSymptomsModal.vue is shown")
      this.fetchOther = init
      this.showModal = true
      this.symptoms = []
      this.searchSymptoms()
      this.searchOtherCircles("a")
    },
    hide() {
      this.symptoms = undefined
      this.selectedCircle = undefined
      this.showModal = false
      this.saving = false
    },
    handleRadioChange(e) {
      this.symptoms.map(smpt => {
        if (e.target.name === smpt.display_name) {
          return (smpt.effectiveness = e.target.value)
        }
      })
    },

    // handleRadioChangeSideEffects(e) {
    //   this.otherSymptoms.map(smpt => {
    //     if (e.target.name === smpt.display_name) {
    //       return (smpt.effectiveness = e.target.value)
    //     }
    //   })
    // },
    /**
     * Search Symptoms
     */
    searchSymptoms(value = "a") {
      this.loading2 = true
      AppRepository.searchSymptoms(value, this.currentCircle)
        .then(res => {
          this.symptomsList = res.data.data.circle_sideeffects ? [...res.data.data.circle_sideeffects] : []
          // console.log("symptomsList:", this.symptomsList)
          // this.otherSymptomsList = res.data.data.other_sideeffects ? [...res.data.data.other_sideeffects] : []
          // console.log("otherSymptomsList:", this.otherSymptomsList)
          this.loading2 = false
        })
        .catch(e => {
          this.loading2 = false
        })
    },

    /**
     * Handle symptoms selection
     */
    handleSymptoms(value) {
      // this.symptoms = value.map(smtp => {
      //   const oldSymptom = this.symptoms.find(symt => {
      //     return symt.display_name === smtp
      //   })
      //   return { display_name: smtp, effectiveness: oldSymptom ? oldSymptom.effectiveness : "50", circle_name: this.selectedCircle }
      // })
      this.symptoms = value.map(smtp => {
        const oldSymptom = this.symptoms.find(symt => {
          return symt.display_name === smtp
        })
        return { display_name: smtp, effectiveness: oldSymptom ? oldSymptom.effectiveness : "50" }
      })
      this.symptomsList.length = 0
    },

    /**
     * Handle Other symptoms selection
     */
    // handleOtherSymptoms(value) {
    //   this.otherSymptoms = value.map(smtp => {
    //     return {
    //       display_name: smtp,
    //       effectiveness: "50",
    //       circle_name: this.selectedCircle,
    //     }
    //   })
    // },

    /**
     * Add Symptoms
     */
    async save() {
      // let oldSymptoms = []
      // UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
      //   .then(res => {
      //     if (res.data) {
      //       oldSymptoms = res.data.data.other_symptoms
      //     }
      //     this.load = true
      //     let payload = null

      //     this.symptoms.map(item => {
      //       return oldSymptoms.map(ele => {
      //         if (item.circle_name === ele.circle_name) {
      //           this.flag = false
      //         }
      //       })
      //     })

      //     if (this.load) {
      //       payload = {
      //         other_symptom: this.symptoms.length
      //           ? oldSymptoms
      //             ? [...this.symptoms, ...oldSymptoms]
      //             : this.symptoms
      //           : oldSymptoms
      //           ? [{ circle_name: this.selectedCircle }, ...oldSymptoms]
      //           : [{ circle_name: this.selectedCircle }],
      //       }
      //     }
      //     const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      //     const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      //     if (this.flag) {
      //       this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
      //         this.fetchOther()
      //       })
      //     } else {
      //       this.$notification.error({ message: "Error", description: "Condition is already added." })
      //     }
      //     this.$store.commit("Posts/setPercent", true)
      //     this.hide()
      //     this.flag = true
      //   })
      //   .catch(err => {
      //     this.saving = false
      //   })
      if (this.saving) {
        return
      }
      try {
        this.saving = true
        const res = await UserRepository.saveOtherConditions({
          user: this.authUser.user.id,
          user_role: this.authUser.user.role,
          user_circle: this.currentCircle.id,
          other_condition: this.selectedCircle,
        })
        if (this.symptoms.length) {
          await UserRepository.saveOtherConditionSymptoms({
            user: this.authUser.user.id,
            user_role: this.authUser.user.role,
            user_circle: this.currentCircle.id,
            othercondition_id: res.data.data.id,
            symptom: this.symptoms.map(s => ({ symptom: s.display_name, effectiveness: s.effectiveness || "50" })),
          })
        }
        this.fetchOther()
        this.$store.commit("Posts/setPercent", true)
        this.hide()
        this.saving = false
      } catch (e) {
        this.saving = false
      }
    },

    searchOtherCircles(value) {
      this.loading1 = true
      AppRepository.getOtherConditions(value)
        .then(res => {
          this.loading1 = false
          this.circleList = res.data.data
          // console.log("circleList:", this.circleList)
        })
        .catch(err => {
          this.loading1 = false
        })
    },

    handleOtherCircle(value) {
      // console.log("handleOtherCircle -> value ->", value)
      this.selectedCircle = value

      // if (this.symptoms) {
      //   this.symptoms.map(ele => {
      //     ele.circle_name = this.selectedCircle
      //     return ele
      //   })
      // }
      // if (this.otherSymptoms) {
      //   this.otherSymptoms.map(ele => {
      //     ele.circle_name = this.selectedCircle
      //     return ele
      //   })
      // }
    },

    removeSymptom(displayName) {
      // console.log("I am in removeSymptom method and display name is ", displayName)
      // console.log("Display name is ", displayName)
      let symptomsArray = [...this.symptoms]
      const removeIndex = symptomsArray.findIndex(symptom => symptom.display_name === displayName)
      // console.log("Remove Index is ", removeIndex)
      symptomsArray.splice(removeIndex, 1)
      // console.log("Updated Symptoms list is ", symptomsArray)
      this.symptoms = symptomsArray
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-modal-title {
  font-weight: 700;
  font-size: 24px;
  color: #33415f;
}

.add-edit-modal .ant-modal-content .ant-modal-header {
  background: #fff !important;
}

.ant-modal-header {
  border-bottom: unset;
}

.anticon {
  font-size: 12px;
  color: #94a3b8;
}
.input-label {
  font-weight: 700;
  font-size: 16px;
  color: #647490;
}
.symptoms-lists {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  @media screen and (max-width: 900px) {
    // flex-direction: column;
    flex-wrap: wrap;
  }
  .symptom-delete {
    margin-left: 50px;
    @media screen and (max-width: 900px) {
      margin-left: 0px;
    }
    i {
      color: #ff9999;
      font-size: 14px;
    }
  }
  .ant-radio-group {
    .ant-radio-wrapper {
      .ant-radio-checked {
        .ant-radio-inner::after {
          color: red;
          background: green;
        }
      }
    }
  }
}

.symptom-effectiveness {
  // height: 300px;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  background: #ffffff;
  border-radius: 5px;
}

.symptom-radio {
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .symp-radiobtn {
    display: flex;
    align-items: center;
  }
  .sideEffectButton {
    margin: 0 8px;
  }
  @media screen and (max-width: 900px) {
    margin-top: 10px;
    width: 100%;
  }
}
.saveButton {
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
}
.dovemed-button {
  padding: 12px 40px;

  @media screen and (max-width: 900px) {
    padding: 12px 32px;
  }
}
// .symptoms-body {
//   @media screen and (max-width: 900px) {
//     height: 80vh;
//   }
// }
.search-icon-one {
  margin-left: 5px;
  left: 20px;
  z-index: 1;
  // top: 42px;
  top: 52px;
  // top: 50px;
  font-size: 20px;
  color: #647490;
}
.search-icon-two {
  margin-left: 5px;
  left: 5px;
  z-index: 1;
  // top: 42.5px;
  top: 50%;
  transform: translateY(20%);
  // transform: translateY(30%);
  font-size: 20px;
  color: #647490;
}
.symp-name {
  width: 136px;
  @media screen and (max-width: 900px) {
    width: auto;
  }
}
.delete-margin {
  margin-left: 5px;
  @media screen and (max-width: 900px) {
    margin-left: 0;
  }
}
@media screen and (max-width: 600px) {
  .mob-one {
    order: 1;
  }
  .mob-two {
    order: 2;
    margin-left: auto;
  }
  .mob-three {
    margin-top: 24px;
    order: 3;
    gap: 24px;
    justify-content: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/OtherSymptomsModal.vue